// extracted by mini-css-extract-plugin
export var section = "bR_d";